import * as React from 'react';
import {Input} from 'antd';
import BaseFormItem, {BaseFormItemProps} from './BaseFormItem';

interface InputFormItemProps extends BaseFormItemProps {
  addonAfter?: React.ReactNode;
  type?: string;
}

class InputFormItem extends React.Component<InputFormItemProps, {}> {
  public render(): React.ReactNode {
    const {disabled, addonAfter, type} = this.props;
    return (
      <BaseFormItem
        {...this.props}
        input={<Input className="mild-disabled" disabled={disabled} addonAfter={addonAfter} type={type}
                      autoComplete={'no'}/>}
      />
    );
  }
}

export default InputFormItem;


// WEBPACK FOOTER //
// ./src/common/form-items/InputFormItem.tsx